import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LookupService } from "../../../app/core/lookup.service";
import { Breadcrumb } from "../../../components/breadcum";
import toast from "react-hot-toast";

export const SingleLogInfo = () => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [singleLogData, setSingleLogData] = useState<any>();

  useEffect(() => {
    getSingleLogsData(params.id);
  }, []);

  const getSingleLogsData = async (id: any) => {
    setLoading(true);
    try {
      const featureGroups = await LookupService.singleLogsData(id);
      setSingleLogData(featureGroups);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error, "error");
    }
  };

  const [breadcrumbInfo] = useState<any>([
    {
      label: "logs",
      value: "logs",
      routerLink: `/dashboard/logs`,
      isActive: false,
    },
    {
      label: params.id,
      value: params.id,
      routerLink: ``,
      isActive: true,
    },
  ]);
  const handleCopy = () => {
    const textToCopy = JSON.stringify(singleLogData, null, 2).replace(/\\/g, "");
    navigator.clipboard.writeText(textToCopy).then(() => {
      toast.success("Text Copied", {duration: 2000,position: "top-right"});
    }).catch(err => {
      toast.error("Failed to copy: ",{duration: 2000,position: "top-right"});
    });
  };

  const downloadTextFile = (filename:any, content:any) => {
    const blob = new Blob([content], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  const handleDownload = () => {
    const content = JSON.stringify(singleLogData, null, 2).replace(/\\/g, "");
    downloadTextFile(params.id, content);
  };
  

  return (
    <div className="container-fluid content-bg-color">
      <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
      {loading ? (
         <div className="text-center p-5">
         <div className="spinner-border" role="status">
           <span className="sr-only"></span>
         </div>
       </div>
      ) : singleLogData ? (
        <div>
          <div className="text-end">
            <button onClick={handleCopy} className="primary-bg text-white rounded border-0 w-25 me-2" style={{ marginBottom: "10px" }}>
              Copy
            </button>
            <button onClick={handleDownload} style={{ marginBottom: "10px" }} className="primary-bg text-white rounded border-0 w-25">
              Download
            </button>
          </div>
          <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
            {JSON.stringify(singleLogData, null, 2).replace(/\\/g, "")}
          </pre>
        </div>
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};
